import {ListQueryParameter} from 'src/models/general/list.query.parameter.model';
import {OrderStatus} from 'src/models/orders/orderStatus';
import {OrderFilterValues} from 'src/services/orders/order.filter.service';

export class OrderSearchParams extends ListQueryParameter {
	orderStatus: OrderStatus[] = [];
	searchQuery: string = '';
	orderNumberQuery: string = '';
	paymentMethodFilter: string[] = [];
	salesChannel: string = '';
	needsReview: boolean = false;
	ignoreNeedsReview: boolean = false;

	initOrderFilter(orderFilter: OrderFilterValues): void {
		this.orderStatus = orderFilter.orderStatus;
		this.salesChannel = orderFilter.salesChannel;
		this.needsReview = orderFilter.needsReview;
		this.searchQuery = orderFilter.searchQuery;
		this.orderNumberQuery = orderFilter.orderNumberQuery;
		this.paymentMethodFilter = orderFilter.paymentFilters;
		this.ignoreNeedsReview = orderFilter.ignoreNeedsReview;
	}

}
